
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/fintech-software-development",
      function () {
        return require("private-next-pages/services/fintech-software-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/fintech-software-development"])
      });
    }
  